import React from "react";
import Box from "@mui/material/Box";

/**
 * GifLoader
 * Props:
 *  - size: width & height of GIF (default 40)
 *  - style: additional CSS styles applied to container
 */
const GifLoader = ({ size = 40, style = {} }) => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",    // full width of parent
                height: "100%",   // full height of parent
                ...style,
            }}
        >
            <img
                src="/loading.gif"
                alt="Loading..."
                width={size}
                height={size}
                style={{ objectFit: "contain" }}
            />
        </Box>
    );
};

export default GifLoader;